export const whyConnectGA = "https://hypolake.com/hypolake-articles/google-analytics-can-help-you-to-measure-your-social-marketing-campaign/"